// extracted by mini-css-extract-plugin
export default {"root":"ClubCard_root__-G-lj","left":"ClubCard_left__JH1eB","logo":"ClubCard_logo__STM4v","right":"ClubCard_right__GXcuP","clubNavItem":"ClubCard_clubNavItem__F8lnC"};